module.exports = __webpack_public_path__ + "img/DE05917.4bda488b.png";